// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ScoreMessageIconCmp from "./ScoreMessageIconCmp.bs.js";
import * as ScoreMessageTextCmp from "./ScoreMessageTextCmp.bs.js";
import * as PartnerScoreCommonCssHelper from "../../../domain/helper/PartnerScoreCommonCssHelper.bs.js";

function ScoreMessageBox(Props) {
  var message_text = Props.message_text;
  var message_box = Props.message_box;
  return React.createElement("div", {
              className: "score-message-box-container"
            }, React.createElement("div", {
                  className: "score-message-box",
                  style: PartnerScoreCommonCssHelper.getMessageBoxStyle(message_box)
                }, React.createElement(ScoreMessageIconCmp.make, {
                      icon_path: message_box.message_box_icon_path
                    }), React.createElement(ScoreMessageTextCmp.make, {
                      message_text: message_text,
                      message_box: message_box
                    })));
}

var make = ScoreMessageBox;

export {
  make ,
  
}
/* react Not a pure module */
